import { Injectable } from '@angular/core';
import { GatewayAPIService } from '../../core/gateway-api.service';
import { TestRun } from './testRun';
import { Test } from './test';

@Injectable({
  providedIn: 'root',
})
export class TestingService {
  //options = { authenticate: true, setRoot: true, updateAuthHeader: false };
  options = { authenticate: true, setRoot: true };

  constructor(private api: GatewayAPIService) {}

  runTests(): Promise<boolean> {
    return this.api.apiCallGateway(
      '/tests/all',
      'POST',
      this.api.getDefaultHeaders(),
      null,
      null,
      this.options,
    );
  }

  getTestRuns(): Promise<TestRun[]> {
    return this.api.apiCallGateway(
      '/tests/runs',
      'GET',
      this.api.getDefaultHeaders(),
      null,
      null,
      this.options,
    );
  }

  getTests(testRunId: string): Promise<Test[]> {
    return this.api.apiCallGateway(
      '/tests/run/tests',
      'GET',
      this.api.getDefaultHeaders(),
      { testRunId: testRunId },
      null,
      this.options,
    );
  }
}
